<div class="block-items-3">
    <ng-content></ng-content>
</div>
